// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-create/orders-create.less
// module id = 3741
// module chunks = 0